import React, { useState } from 'react';
import MetricRow from './MetricRow';
import AutoInsightRow from './AutoInsightRow';
import { EditMetricCategoryPanelProps } from '../types';
import { isSearchedItem } from '../utils';
import { AUTO_INSIGHT_NOTIFICATION_CATEGORY } from '../../utils';
import { Button, Collapse, Tooltip } from 'antd';
import {
  StyledSearch,
  StyledCollapse,
  MetricsActionWrapper,
  BetaTag,
  SubscriptionCategoryName,
} from './styled';
import { NoData } from '@src/components/common/Retry/styled';

const EditMetricCategoryPanels = ({
  categoryMap,
  form,
  searchProps,
}: EditMetricCategoryPanelProps) => {
  const { searchText, setSearchText } = searchProps;
  const collapsible: boolean = Object.keys(categoryMap).length > 1;
  const metricSeverityList = form.getFieldValue('metricList');

  const handleDeselectAll = () => {
    form.setFieldValue('metricList', {});
  };

  const handleSearch = (event) => {
    event?.stopPropagation();
    setSearchText(event.target.value);
  };

  return (
    <>
      <MetricsActionWrapper>
        <Tooltip title={'Click to clear all metric severities'}>
          <Button onClick={handleDeselectAll}>Clear selections</Button>
        </Tooltip>

        <StyledSearch
          placeholder="Search metric"
          allowClear
          value={searchText}
          onChange={handleSearch}
        />
      </MetricsActionWrapper>
      {categoryMap.length === 0 ? (
        <NoData emptyPlaceholder="No metrics found for your search." />
      ) : (
        categoryMap.map(({ key, metrics }) =>
          metrics.length > 0 && !!metricSeverityList ? (
            <StyledCollapse
              defaultActiveKey={[`${key}key`]}
              key={key}
              collapsible={collapsible ? 'header' : 'disabled'}
            >
              <Collapse.Panel
                key={`${key}key`}
                header={
                  key === AUTO_INSIGHT_NOTIFICATION_CATEGORY ? (
                    <span>
                      <SubscriptionCategoryName>{key}</SubscriptionCategoryName>
                      <sup>
                        <BetaTag color="#0046ff">New</BetaTag>
                      </sup>
                    </span>
                  ) : (
                    <SubscriptionCategoryName>{key}</SubscriptionCategoryName>
                  )
                }
                showArrow={collapsible}
              >
                {metrics.map(({ name, displayName }) => {
                  if (!isSearchedItem(displayName, searchText)) {
                    return null;
                  }
                  if (key === AUTO_INSIGHT_NOTIFICATION_CATEGORY) {
                    // auto insight
                    return (
                      <AutoInsightRow
                        key={name}
                        itemKey={name}
                        itemLabel={displayName}
                        option={metricSeverityList?.[name]?.option}
                        form={form}
                        searchText={searchText}
                      />
                    );
                  }
                  // ai alert
                  return (
                    <MetricRow
                      key={name}
                      metricKey={name}
                      metricLabel={displayName}
                      metricSeverity={metricSeverityList?.[name]?.severity}
                      form={form}
                      searchText={searchText}
                    />
                  );
                })}
              </Collapse.Panel>
            </StyledCollapse>
          ) : null,
        )
      )}
    </>
  );
};

export default EditMetricCategoryPanels;
